/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpIcon20Regular = forwardRef('ArrowShapeAUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.411 2.228a2.25 2.25 0 0 1 3.18 0l6.977 6.967c.851.85.249 2.306-.954 2.306H14.75V16a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2v-4.5H2.388c-1.203 0-1.805-1.456-.954-2.306l6.977-6.967Zm2.12 1.062a.75.75 0 0 0-1.06 0L2.751 10H6a.75.75 0 0 1 .75.75V16a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-5.25A.75.75 0 0 1 14 10h3.251l-6.72-6.71Z" })));
});
